import { request } from '@/shared/api/request'

export const personVerification = (payload, flEmployer = false) => {
	return request({ url: `/user/person/verification?flEmployer=${flEmployer}`, method: 'POST', data: payload })
}
